import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { sentryCatch } from 'src/modules/config/utils/sentryCatch';
import { PROJECT_EVENT_SEND } from 'src/modules/project-event/actions/ProjectEventActions';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { GetTriggerActionType } from 'src/utils/createTrigger';
import { call } from 'typed-redux-saga';

export function* projectEventSendSaga(
  action: GetTriggerActionType<typeof PROJECT_EVENT_SEND>,
): SagaIterator<void> {
  const event = action.data;
  const project = action.meta;

  try {
    yield* call(logDebug, `Sending project "${project.id}" event...`, event);

    yield* call(
      makeRestRequest,
      'POST',
      `/projects/${encodeURIComponent(project.id)}/events`,
      event,
    );

    yield* call(logDebug, `Sending project "${project.id}" event... done`);
  } catch (error) {
    yield* call(logError, `Sending project "${project.id}" event... error`, error);
    yield* call(sentryCatch, new RuntimeError(
      'Could not send project event',
      { event, project },
      NativeError.wrap(error),
    ));
  }
}
